"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _has = _interopRequireDefault(require("lodash/has"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _find = _interopRequireDefault(require("lodash/find"));
var _clsx = _interopRequireDefault(require("clsx"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _BlockRounded = _interopRequireDefault(require("@material-ui/icons/BlockRounded"));
var _InfoRounded = _interopRequireDefault(require("@material-ui/icons/InfoRounded"));
var _RestoreRounded = _interopRequireDefault(require("@material-ui/icons/RestoreRounded"));
var _WarningRounded = _interopRequireDefault(require("@material-ui/icons/WarningRounded"));
var _styles = require("@material-ui/core/styles");
var _Markdown = _interopRequireDefault(require("../../../../../Framework/Components/Markdown"));
var _i18n = require("../../../../../Framework/i18n");
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _OptionAmount = _interopRequireDefault(require("../OptionAmount"));
var _OptionGroup = _interopRequireDefault(require("../OptionGroup"));
var _getImageUrl = _interopRequireDefault(require("../../../../Utils/getImageUrl"));
var _excluded = ["children", "render"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = function styles(theme) {
  var textWidthWithAmount = theme.creator.option.image.width !== 'auto' ? "calc(94% - (".concat(theme.creator.option.image.width, " + 35px))") : theme.creator.option.textArea.textWidth;
  var customValues = {
    icon: {
      fontSize: '16px',
      lineHeight: 1.6
    },
    image: {
      fontSize: '11px',
      lineHeight: '11px'
    },
    textArea: {
      fontSize: '0.8em',
      title: {
        fontWeight: 'bold'
      }
    }
  };
  return {
    description: {},
    materialIcon: {},
    price: {},
    details: {
      display: 'inline-block'
    },
    iconWithText: {
      lineHeight: customValues.icon.lineHeight,
      display: 'flex',
      verticalAlign: 'middle',
      '& $materialIcon': {
        "float": 'left',
        display: 'inline-block',
        paddingRight: '8px',
        minWidth: '20px',
        textAlign: 'center'
      }
    },
    optionList: {
      overflow: 'hidden'
    },
    title: {
      fontWeight: 'bold',
      display: '-webkit-box',
      overflow: 'hidden',
      wordWrap: 'break-word',
      boxOrient: 'vertical',
      lineClamp: 3,
      textOverflow: 'ellipsis'
    },
    image: {
      display: 'inline-block',
      "float": 'left',
      height: '100%',
      maxHeight: '100%',
      maxWidth: theme.creator.option.image.width,
      marginRight: '10px',
      fontSize: 0,
      '& img': {
        maxHeight: '100%',
        maxWidth: '100%'
      },
      '& .imageNotAvailableElement': {
        padding: '4px',
        lineHeight: customValues.image.lineHeight,
        fontSize: customValues.image.fontSize
      }
    },
    root: {
      minHeight: '100px',
      padding: 10,
      cursor: 'pointer',
      fontSize: customValues.textArea.fontSize,
      display: 'table',
      width: '94%',
      '& .content': {
        position: 'relative',
        display: 'table-cell',
        verticalAlign: 'middle',
        margin: 0
      },
      '& .disabled': {
        cursor: 'not-allowed',
        opacity: '0.8'
      },
      '&.selected': {
        backgroundColor: '#d8d8d8'
      },
      tapHighlightColor: theme.tapHighlightColor
    },
    text: {
      "float": 'left',
      width: 'calc(94% - ' + theme.creator.option.image.width + ')',
      '& a': {
        textDecoration: 'underline'
      },
      '& $description': {
        marginBottom: 10,
        '& p': {
          margin: 0
        }
      },
      '& $price': {
        marginBottom: 10
      },
      '& $title': {
        fontWeight: customValues.textArea.title.fontWeight,
        marginBottom: '10px'
      }
    },
    withAmount: {
      '& $text': {
        width: textWidthWithAmount
      }
    },
    optionTextInput: {}
  };
};
var Option = function Option(_ref) {
  var children = _ref.children,
    render = _ref.render,
    props = _objectWithoutProperties(_ref, _excluded);
  var className = props.className,
    onClick = props.onClick,
    onSelect = props.onSelect,
    onToggle = props.onToggle,
    onInputTextChange = props.onInputTextChange,
    option = props.option,
    optionclassification = props.optionclassification,
    selected = props.selected,
    viewDetails = props.viewDetails,
    viewStockInformation = props.viewStockInformation,
    OptionAmountComponent = props.OptionAmountComponent,
    OptionGroupComponent = props.OptionGroupComponent,
    classes = props.classes,
    isAdminMode = props.isAdminMode;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    imageAvailable = _useState2[0],
    setImageAvailable = _useState2[1];
  var selectedoptions = optionclassification.selectedoptions;
  var _useState3 = (0, _react.useState)((0, _get["default"])((0, _find["default"])(selectedoptions, ['identifier', option.identifier]), 'inputText', '')),
    _useState4 = _slicedToArray(_useState3, 2),
    inputText = _useState4[0],
    setInputText = _useState4[1];
  var query = new URLSearchParams(location.search);
  var hidePrices = query.has('_hide_prices') && query.get('_hide_prices') === '1';
  var smallerScreen = (0, _useMediaQuery["default"])('(min-device-width : 300px) and (max-device-width : 340px)');
  var thumbnail = (0, _get["default"])(option, 'thumbnail', '');
  var detailImage = (0, _get["default"])(option, 'detailImage');
  var optionIdentifier = (0, _get["default"])(option, 'identifier', '');
  var amountIsSelectable = (0, _get["default"])(option, 'amount_is_selectable', false);
  var resultStatus = (0, _get["default"])(option, 'check_results.status', true);
  var optionIsMultiSelect = (0, _get["default"])(option, 'is_multiselect', false);
  var optionAmount = (0, _get["default"])(option, 'amount', 0);
  var hasTextinput = (0, _get["default"])(option, 'hasTextinput', false);
  var translations = _objectSpread(_objectSpread({}, (0, _i18n.t)('common')), (0, _i18n.t)('optionlistitem'));
  var setImageAvailability = function setImageAvailability() {
    setImageAvailable(!imageAvailable);
  };
  var isEnabled = function isEnabled() {
    return (0, _get["default"])(option, 'stock.traffic_light', false) !== 'red';
  };
  var shouldDisplayDetails = function shouldDisplayDetails() {
    var displayDetails = false;
    if (option["abstract"] || option.description || detailImage) {
      displayDetails = true;
    }
    return displayDetails;
  };
  var onOptionSelected = function onOptionSelected() {
    var optionClassificationIsMultiselect = (0, _get["default"])(optionclassification, 'is_multiselect', false);
    if (amountIsSelectable) {
      onSelect(_objectSpread(_objectSpread({}, option), {}, {
        amount: !optionAmount ? 1 : optionAmount
      }));
    } else if (optionClassificationIsMultiselect || isAdminMode) {
      onSelect(_objectSpread(_objectSpread({}, option), {}, {
        amount: selected ? 0 : 1
      }));
    } else if (!selected) {
      onSelect(_objectSpread(_objectSpread({}, option), {}, {
        amount: 1
      }));
    }
  };
  var onOptionClicked = function onOptionClicked(event) {
    event.preventDefault();
    event.stopPropagation();
    if (isEnabled() && !(hasTextinput && selected)) {
      onOptionSelected();
      onClick();
    }
  };
  var onAmountChanged = function onAmountChanged(optionAmount) {
    if (!isEnabled()) {
      return;
    }
    var amount;
    if (amountIsSelectable) {
      amount = optionAmount;
    } else if (optionIsMultiSelect) {
      amount = selected ? 0 : 1;
    } else if (!selected) {
      amount = 1;
    }
    if (amount < 0) {
      return; // prevent setting below 0
    }

    onSelect(_objectSpread(_objectSpread({}, option), {}, {
      amount: amount
    }));
  };
  var onAbstractClicked = function onAbstractClicked(event) {
    event.target.tagName.toLowerCase() === 'a' && event.stopPropagation();
  };
  var onDetailsClicked = function onDetailsClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    if (isEnabled()) {
      viewDetails(option);
    }
  };
  var onIncompatibilityClicked = function onIncompatibilityClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    if (isEnabled()) {
      onOptionSelected();
    }
  };
  var onOptionGroupClicked = function onOptionGroupClicked(event) {
    event.stopPropagation();
  };
  var onOptionGroupItemSelected = function onOptionGroupItemSelected(option) {
    onSelect(_objectSpread(_objectSpread({}, option), {}, {
      amount: 1
    }));
  };
  var onLateDeliveryClicked = function onLateDeliveryClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    if (isEnabled()) {
      viewStockInformation(option);
    }
  };
  var renderImage = function renderImage() {
    var src = (0, _getImageUrl["default"])(thumbnail);
    return src && /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      onError: setImageAvailability
    });
  };
  var renderNotAvailableImage = function renderNotAvailableImage() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'imageNotAvailableElement'
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: 'caption'
    }, translations.imageNotAvailable));
  };
  var renderStockStatus = function renderStockStatus() {
    if (option.stock) {
      switch (option.stock.traffic_light) {
        case 'red':
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.iconWithText
          }, /*#__PURE__*/_react["default"].createElement(_BlockRounded["default"], {
            className: classes.materialIcon
          }), ' ', /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            variant: 'body2'
          }, translations.notAvailable));
        case 'yellow':
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
            className: classes.iconWithText,
            onClick: onLateDeliveryClicked
          }, /*#__PURE__*/_react["default"].createElement(_RestoreRounded["default"], {
            className: classes.materialIcon
          }), ' ', /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            variant: 'body2'
          }, translations.lateDelivery)));
        case 'green':
          return null;
      }
    }
    return null;
  };
  var renderOptionGroup = function renderOptionGroup() {
    if (!isEnabled()) {
      return null;
    }
    var optionGroup = (0, _get["default"])(option, 'option_group', {});
    if ((0, _has["default"])(optionGroup, 'children') && (0, _isArray["default"])(optionGroup.children) && optionGroup.children.length > 0) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: onOptionGroupClicked
      }, /*#__PURE__*/_react["default"].createElement(OptionGroupComponent, {
        itemGroup: optionGroup,
        option: option,
        optionclassification: optionclassification,
        onOptionSelect: onOptionGroupItemSelected,
        selected: selected,
        onToggle: onToggle
      }));
    }
    return null;
  };
  var renderActions = function renderActions() {
    var displayDetails = shouldDisplayDetails();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.details
    }, displayDetails && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
      className: classes.iconWithText,
      onClick: onDetailsClicked
    }, /*#__PURE__*/_react["default"].createElement(_InfoRounded["default"], {
      className: (0, _clsx["default"])(classes.materialIcon, (0, _customClassName["default"])('rule-info-icon-option'))
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: 'body2',
      className: classes.iconWithText
    }, translations.details))), resultStatus !== true && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
      className: classes.iconWithText,
      onClick: onIncompatibilityClicked
    }, /*#__PURE__*/_react["default"].createElement(_WarningRounded["default"], {
      className: (0, _clsx["default"])(classes.materialIcon, (0, _customClassName["default"])('rule-alert-icon-option'))
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: 'body2'
    }, translations.incompatibility))), renderStockStatus(), renderOptionGroup());
  };
  var renderText = function renderText() {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      component: 'div',
      className: classes.optionList,
      variant: 'body2'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.title
    }, option.title), hasTextinput && renderTextInput(), !hidePrices && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.price
    }, option.priceFormatted), smallerScreen && renderControls('horizontal'), option["abstract"] && /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
      className: classes.description,
      onClick: onAbstractClicked
    }, option["abstract"]), renderActions()));
  };
  var renderControls = function renderControls(view) {
    if (isEnabled() && amountIsSelectable) {
      return /*#__PURE__*/_react["default"].createElement(OptionAmountComponent, {
        view: view,
        option: option,
        onAmountChange: onAmountChanged,
        onSelect: onSelect
      });
    } else {
      return null;
    }
  };
  var handleTextInputChange = function handleTextInputChange(event) {
    setInputText(event.target.value);
    onInputTextChange(option.identifier, event.target.value);
  };
  var renderTextInput = function renderTextInput() {
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      className: classes.optionTextInput,
      label: '',
      value: inputText,
      onChange: handleTextInputChange,
      disabled: !selected
    });
  };
  var getRootClassName = function getRootClassName() {
    return (0, _clsx["default"])(classes.root, selected && 'selected', (0, _customClassName["default"])('option'));
  };
  var getContentClassName = function getContentClassName() {
    var amountClass = amountIsSelectable && !smallerScreen ? classes.withAmount : '';
    return (0, _clsx["default"])('content', className, optionIdentifier, amountClass, !isEnabled() && 'disabled', resultStatus !== true && 'incompatible');
  };
  var getRenderProps = function getRenderProps() {
    return _objectSpread(_objectSpread({}, props), {}, {
      imageAvailable: imageAvailable,
      smallerScreen: smallerScreen,
      renderImage: renderImage,
      renderNotAvailableImage: renderNotAvailableImage,
      renderText: renderText,
      renderControls: renderControls,
      renderActions: renderActions,
      renderOptionGroup: renderOptionGroup,
      renderStockStatus: renderStockStatus,
      setImageAvailability: setImageAvailability,
      isEnabled: isEnabled,
      shouldDisplayDetails: shouldDisplayDetails,
      onOptionSelected: onOptionSelected,
      onOptionClicked: onOptionClicked,
      onAmountChanged: onAmountChanged,
      onAbstractClicked: onAbstractClicked,
      onDetailsClicked: onDetailsClicked,
      onIncompatibilityClicked: onIncompatibilityClicked,
      onOptionGroupClicked: onOptionGroupClicked,
      onOptionGroupItemSelected: onOptionGroupItemSelected,
      onLateDeliveryClicked: onLateDeliveryClicked,
      getRootClassName: getRootClassName,
      getContentClassName: getContentClassName
    });
  };
  var renderItem = function renderItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: getRootClassName(),
      "data-option": option.identifier,
      onClick: onOptionClicked
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: getContentClassName()
    }, typeof children === 'function' ? children(getRenderProps()) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.image
    }, imageAvailable ? renderImage() : renderNotAvailableImage()), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.text
    }, renderText()), !smallerScreen && renderControls())));
  };
  return typeof render === 'function' ? render(getRenderProps()) : renderItem();
};
Option.defaultProps = {
  className: '',
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onToggle: function onToggle() {},
  onInputTextChange: function onInputTextChange() {},
  optionclassification: {},
  option: {},
  selected: false,
  translations: {},
  viewDetails: function viewDetails() {},
  viewStockInformation: function viewStockInformation() {},
  OptionAmountComponent: _OptionAmount["default"],
  OptionGroupComponent: _OptionGroup["default"]
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'Option'
})(Option);